<template>
    <basicSearch :onSearchApi="onSearchApi" placeholder="搜索英雄" v-bind="$attrs" v-on="$listeners"></basicSearch>
</template>

<script>

import basicSearch from '@/components/basic/search.vue';
import { searchHero } from '@/api/games/hero';


export default {
    name: "hero-search",
    components: {
        basicSearch
    },
    data () {
        return {
            onSearchApi: searchHero,
        }
    }
}
</script>
